import type { LovCappDTO } from '@/features/api/extranet/dto/Demande/CAPP'
import {
  getNaturesFichiersCapp as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/CAPP'
import { cappService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'

export const useDemandeCAPPStore = buildDemandeStore<'MODEL_CAPP', LovCappDTO>({
  model: 'MODEL_CAPP',
  typeDemande: 'Formation',
  module: 'demande',
  demandeService: cappService,
  propertyStatusConfiguration,
  reglesConfiguration,
  getNaturesFichiers,
})
